import serverInterface from 'server-interface';

import types from './elements/types';

function collectCarouselNodes(node, accumulator) {

  if (node === null || typeof node !== 'object') {
    return;
  }

  if (node.type === types.CAROUSEL) {
    accumulator.push(node);
    return;
  }

  if (node.type === types.CAROUSEL_ITEM) {
    accumulator.push(node);
    return;
  }

  if (Array.isArray(node.children) === false) {
    return;
  }

  for (let child of node.children) {
    collectCarouselNodes(child, accumulator);
  }

}

function markNodeForDeletion(node) {

  const properties = node.properties || {};

  if (node.type === types.CAROUSEL) {

    if (typeof properties.carouselId !== 'string') {
      return;
    }

    serverInterface.startup.pages.markCarouselForDeletion(properties.carouselId);
    return;

  }

  if (typeof properties.carouselItemId !== 'string' || typeof properties.carouselId !== 'string') {
    return;
  }

  serverInterface.startup.pages.markCarouselItemForDeletion(properties.carouselId, properties.carouselItemId);

}

function unmarkNodeForDeletion(node) {

  const properties = node.properties || {};

  if (node.type === types.CAROUSEL) {

    if (typeof properties.carouselId !== 'string') {
      return;
    }

    serverInterface.startup.pages.unmarkCarouselForDeletion(properties.carouselId);
    return;

  }

  if (typeof properties.carouselItemId !== 'string' || typeof properties.carouselId !== 'string') {
    return;
  }

  serverInterface.startup.pages.unmarkCarouselItemForDeletion(properties.carouselId, properties.carouselItemId);

}

export default function trackCarouselResources(editor) {

  const operations = editor.operations;

  for (let operation of operations) {

    const operationType = operation.type;

    if (operationType !== 'remove_node' && operationType !== 'insert_node') {
      continue;
    }

    const accumulator = [];

    collectCarouselNodes(operation.node, accumulator);

    for (let node of accumulator) {

      if (operationType === 'remove_node') {
        markNodeForDeletion(node);
      } else {
        unmarkNodeForDeletion(node);
      }

    }

  }

}
